__turbopack_context__.v({
  "bazaarvoice-review-empty": "bazaarvoice-review-empty-component-module-scss-module__MYgoHq__bazaarvoice-review-empty",
  "bazaarvoice-review-empty__message": "bazaarvoice-review-empty-component-module-scss-module__MYgoHq__bazaarvoice-review-empty__message",
});
